import React, { useEffect, useState } from 'react'

import clsx from 'clsx'
import ReactDOM from 'react-dom'

import getScrollbarSize from 'helpers/getScrollbarSize'
import { useTransition } from 'hooks'

import classes from './DialogRoot.module.scss'

/** @type {import("./types").default} */
const DialogRoot = ({
  children,
  className,
  isOpen,
  onClose,
  fullScreen,
  maxWidth,
  fullWidth,
  isSeoFriendly = false,
  paperProps = {},
  ...rest
}) => {
  const { className: paperClassName, ...paperRestProps } = paperProps
  const { shouldMount, stage } = useTransition(isOpen, 300)
  const [shouldBeInDom, setShouldBeInDom] = useState(false)

  useEffect(() => {
    setShouldBeInDom(() => isSeoFriendly)
  }, [isSeoFriendly])

  useEffect(() => {
    if (!isOpen) return
    document.body.style.paddingRight = `${getScrollbarSize()}px`
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.paddingRight = '0'
      document.body.style.overflow = 'initial'
    }
  }, [isOpen])

  return (
    (shouldBeInDom || shouldMount) &&
    ReactDOM.createPortal(
      <div
        className={clsx('DialogRoot', classes.root, classes[stage], className, { [classes.isInvisible]: !shouldMount })}
        {...rest}
        role="presentation"
      >
        <div className={clsx(classes.overlay)} onClick={onClose} role="dialog" />
        <div className={clsx(classes.container)}>
          <div
            className={clsx(
              classes.elevation,
              {
                [classes[`width-${maxWidth}`]]: maxWidth,
                [classes.fullScreen]: fullScreen,
                [classes.fullWidth]: fullWidth,
              },
              classes.card,
              paperClassName
            )}
            {...paperRestProps}
          >
            {children}
          </div>
        </div>
      </div>,
      document?.getElementById('portal_root') || document.body
    )
  )
}

export default DialogRoot
